<script setup>
import {onMounted, ref} from 'vue';

defineProps({
  modelValue: null,
  padding: {
    type: String,
    default: 'p-2.5'
  }
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
  if (input.value.hasAttribute('autofocus')) {
    input.value.focus();
  }
});

defineExpose({focus: () => input.value.focus()});
</script>

<template>
  <input ref="input"
         class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block disabled:bg-white disabled:border-gray-200 disabled:text-gray-500"
         :class="padding"
         :value="modelValue"
         @input="$emit('update:modelValue', $event.target.value)"
  >
</template>
